import declare from "dojo/_base/declare";
import PhaseFreezeController from "./PhaseFreezeController";
import _StartApprovalWorkflowMixin from "csi/breadcrumb/_StartApprovalWorkflowMixin";

const PhaseFreezeStartApprovalWorkflowController = declare([PhaseFreezeController, _StartApprovalWorkflowMixin], {

});

export = PhaseFreezeStartApprovalWorkflowController;